import getFileNameFromUrl from "@/lib/getFileNameFromUrl";
import getFileNameWithoutRandomExtension from "@/lib/getFileNameWithoutRandomExtension";
export default url =>
  url ? getFileNameWithoutRandomExtension(getFileNameFromUrl(url)) : "N/A";
